module.exports = __webpack_public_path__ + "static/media/asee.dab44096.png";